
CheckoutV2.Payment.WireTransfer = function(checkout, payment, extra, isReview) {
	var wiretransfer = this;

	this.label = 'Wire Transfer';
	this.fee = parseFloat(checkout.config.wireTransferFee);

	this.allowMulti = false;
	this.multiError = 'Wire Transfer payments can\'t be combined with any other payment method';

	this.$wrap = $( $.parseHTML( Jemplate.process('includes/partials/payment/wireTransfer.html', { fee: wiretransfer.fee.toMoney() }) ) );
	
	this.$feeWrap = $('.js-wire-transfer');
	this.$fee = $('.js-wire-transfer-fee');
	
    this.reviewSelector = '.';
    if (isReview) 
       this.reviewSelector += 'review-';

	var getContainer = function() {
		return $(wiretransfer.reviewSelector + 'payment-method-wiretransfer-container');
	}
	
	this.init = function() {
		wiretransfer.getContainer = getContainer;
		
		if (Object.keys(payment.methods).length) {
			wiretransfer.addError = wiretransfer.multiError;
			return;
		}
				
		wiretransfer.$feeWrap.show();
		wiretransfer.$fee.text( '+$' + wiretransfer.fee.toMoney() );
		payment.changeFees(wiretransfer, wiretransfer.fee, true);
	};

	this.afterRemoved = function() {
		payment.changeFees(wiretransfer, 0, true);
		wiretransfer.$feeWrap.hide();
		wiretransfer.$fee.text( '+$' );
	};
	
	this.applyFee = function() {
		wiretransfer.$feeWrap.show();
		wiretransfer.$fee.text( '+$' + wiretransfer.fee.toMoney() );
		payment.changeFees(wiretransfer, wiretransfer.fee, true);
	};
	
	this.removeFee = function() { // alias
		wiretransfer.afterRemoved();
	};

    this.buildReview = function() {
        var card = wiretransfer;
        var data = {
                    method: 'wiretransfer',
                    method_name: card.label,
                    payment_amount: payment.getMethodAmt( card ),
                };
        return data;
    };


	this.getData = function() {
		return {};
	};

	this.init();
};

